import type { CertificateCheckInfo } from '@/api/models/medcomplex'

export const getNotificationText = (
  notification: CertificateCheckInfo | undefined
) => {
  if (notification) {
    switch (notification?.status?.slug) {
      case 'BLOCKED_SOON':
        return (
          <>
            {`Cрок действия сертификата медкомлекса «${notification?.bluetooth_serial_number}» истекает `}
            <b>{`через ${notification?.days_left} ${getRusDayLabel(
              notification?.days_left
            )}`}</b>
          </>
        )
      case 'BLOCKED':
        return (
          <>
            {`Cрок действия сертификата медкомлекса «${notification?.bluetooth_serial_number}» истек ${notification?.date_expiration}, `}
            <b>{`медкомлекс заблокирован`}</b>
          </>
        )
      default:
        return <>{notification.status?.slug}</>
    }
  }
}

export const getRusDayLabel = (day?: string | null) => {
  if (day !== null && day !== undefined) {
    if (day.length > 1 && day[day.length - 2] === '1') {
      return 'дней'
    } else {
      const lastnum = Number(day[day.length - 1])
      if (lastnum === 1) {
        return 'день'
      } else if (lastnum >= 2 && lastnum <= 4) {
        return 'дня'
      } else if (lastnum === 0 || (lastnum >= 5 && lastnum <= 9)) {
        return 'дней'
      }
    }
  } else {
    return ''
  }
}
